import { Alert } from 'avo-ui'
import { CategoryWinner } from 'components/award/award-winner/category-winner/CategoryWinner'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    is_show: false,
    title_image_url: null,
    categories: [
        {
            image_url: null,
            title: null,
            subcategories: [
                {
                    image_url: null,
                    title: null,
                },
            ],
        },
    ],
}

export const CategoryWinnerContainer = () => {
    const [categoryDetail, setCategoryDetail] = useState(INITIAL_STATE)
    const copyItems = [...(categoryDetail?.categories || [])]
    const [errorForm, setErrorForm] = useState({})
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getCategory, isLoading } = useFetch(API_AWARD.WINNER_CATEGORY)
    const { fetching: updateCategory, isLoading: isUpdating } = useFetch({
        ...API_AWARD.WINNER_CATEGORY,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)

    useEffect(() => {
        fetchCategory()
    }, [])

    const fetchCategory = async () => {
        const response = await getCategory()
        let responseData = response?.data

        if (response?.data?.categories?.length === 0) {
            responseData = {
                ...responseData,
                categories: [...INITIAL_STATE.categories],
            }
        }
        setCategoryDetail(responseData)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setCategoryDetail({ ...categoryDetail, [name]: value })
    }

    const setItems = (items) => {
        setCategoryDetail({ ...categoryDetail, categories: items })
    }

    const setSubItems = (items, index) => {
        const updatedCategories = [...categoryDetail.categories]
        updatedCategories[index] = {
            ...updatedCategories[index],
            subcategories: items,
        }
        setCategoryDetail({ ...categoryDetail, categories: updatedCategories })
    }

    const onChangeItem = (e) => {
        const { name, value, parentIndex } = e
        copyItems[parentIndex][name] = value
        setItems(copyItems)
    }

    const onChangeSubItem = (e) => {
        const { name, value, parentIndex, index } = e
        copyItems[parentIndex].subcategories[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                image_url: null,
                title: null,
                subcategories: [
                    {
                        image_url: null,
                        title: null,
                    },
                ],
            },
        ])
    }

    const addSubItem = (index) => {
        const subItem = {
            image_url: null,
            title: null,
        }
        categoryDetail?.categories?.[index]?.subcategories?.push(subItem)
        setCategoryDetail({ ...categoryDetail })
    }

    const handleUploadImage = async (files) => {
        try {
            let newFormImage = {}
            if (files?.title_image_url) {
                const fileNames = Object.entries(files)
                    .map(([key, item]) => item.name)
                    .filter((item) => item)

                const s3Urls = await getURLImage({ files: fileNames })

                const newEntries = Object.entries(files).reduce((acc, [key, item], index) => {
                    if (key === 'categories') return acc
                    acc.push([key, { ...item, ...s3Urls?.data?.[index] }])
                    return acc
                }, [])

                const s3UrlsWithKey = Object.fromEntries(newEntries)
                await Promise.all(
                    Object.entries(s3UrlsWithKey).map(async ([key, item], index) => {
                        await uploadFileToS3(item, item.file)
                        newFormImage = {
                            ...newFormImage,
                            [key]: `${s3UrlsWithKey?.[key]?.url}${s3UrlsWithKey?.[key]?.fields?.key}`,
                        }
                    }),
                )
            }

            if (files?.categories?.length > 0) {
                let newFiles = []

                for (const categoryItem of files?.categories) {
                    let subNewSubFiles = []
                    if (categoryItem?.subcategories?.length > 0) {
                        const subFileNames = categoryItem?.subcategories?.map((item) => item.image_url.name)
                        const s3Urls = await getURLImage({ files: subFileNames })

                        await Promise.all(
                            s3Urls?.data?.map(async (item, index) => {
                                const itemFile = { image_url: '', currentIndex: '' }
                                await uploadFileToS3(item, categoryItem?.subcategories?.[index]?.image_url?.file)
                                itemFile.image_url = `${item?.url}${item?.fields?.key}`
                                itemFile.currentIndex = categoryItem?.subcategories?.[index]?.currentIndex
                                subNewSubFiles.push(itemFile)
                            }),
                        )
                    }
                    newFiles.push({
                        ...categoryItem,
                        subcategories: [...subNewSubFiles],
                    })
                }

                const fileArrayParent = files?.categories
                    .map((item, index) => ({ ...item, parentIndex: index }))
                    .filter((item) => item?.image_url?.file)

                const fileNames = fileArrayParent.map((item) => item.image_url.name)
                const s3Urls = await getURLImage({ files: fileNames })

                await Promise.all(
                    s3Urls?.data?.map(async (item, index) => {
                        let imageURL = ''
                        await uploadFileToS3(item, fileArrayParent[index]?.image_url?.file)
                        imageURL = `${item?.url}${item?.fields?.key}`
                        newFiles[fileArrayParent[index]?.parentIndex] = {
                            ...newFiles[fileArrayParent[index]?.parentIndex],
                            image_url: imageURL,
                        }
                    }),
                )

                newFormImage = { ...newFormImage, categories: [...newFiles] }
            }

            return newFormImage
        } catch {
            setLoadingUpload(false)
        }
    }

    const validationForm = () => {
        const newErrorForm = { ...errorForm }
        if (!categoryDetail.title_image_url) {
            newErrorForm.title_image_url = 'Image title wajib diisi'
        } else {
            newErrorForm.title_image_url = ''
        }

        const errorArrayItem = []
        let categoryIndex = 0

        for (const item of categoryDetail.categories) {
            const itemError = { image_url: '', title: '', subcategories: [] }
            if (!item.image_url) itemError.image_url = 'Category icon wajib diisi'
            if (!item.title) itemError.title = 'Title wajib diisi'
            errorArrayItem.push(itemError)

            if (item?.subcategories?.length > 0) {
                for (const subitem of item?.subcategories) {
                    const itemError = { image_url: '', title: '' }
                    if (!subitem.image_url) itemError.image_url = 'Category icon wajib diisi'
                    if (!subitem.title) itemError.title = 'Title wajib diisi'
                    errorArrayItem[categoryIndex].subcategories.push(itemError)
                }
            }
            categoryIndex++
        }
        newErrorForm.categories = [...errorArrayItem]

        return newErrorForm
    }

    const isValid = (data) => {
        if (typeof data === 'string') {
            return data === ''
        }
        if (Array.isArray(data)) {
            return data.every(isValid)
        }
        if (typeof data === 'object' && data !== null) {
            return Object.values(data).every(isValid)
        }
        return false
    }

    const onSubmit = async () => {
        const findErrors = validationForm()
        setErrorForm(findErrors)
        if (!isValid(findErrors)) return

        let files = {}
        if (categoryDetail?.title_image_url?.file)
            files = { ...files, title_image_url: categoryDetail?.title_image_url }

        let payload = { ...categoryDetail }

        const fileArray = categoryDetail.categories
            .map((item, parentIndex) => ({
                ...item,
                subcategories: item.subcategories
                    .map((subItem, index) => ({ ...subItem, currentIndex: index }))
                    .filter((subItem) => subItem?.image_url?.file),
                currentIndex: parentIndex,
            }))
            .filter((item) => item?.image_url?.file || item?.subcategories?.length > 0)

        if (fileArray.length > 0) {
            files = { ...files, categories: fileArray }
        }

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            const filePayload = await handleUploadImage(files)
            payload = {
                ...payload,
                ...(filePayload?.title_image_url && { title_image_url: filePayload?.title_image_url }),
            }

            if (filePayload?.categories?.length > 0) {
                for (const itemFile of filePayload?.categories) {
                    if (itemFile?.image_url) {
                        payload.categories[itemFile?.currentIndex].image_url = itemFile?.image_url
                    }

                    for (const itemSubFile of itemFile?.subcategories) {
                        payload.categories[itemFile?.currentIndex].subcategories[itemSubFile?.currentIndex].image_url =
                            itemSubFile?.image_url
                    }
                }
            }
            setLoadingUpload(false)
        }
        await updateCategory(payload)
        await fetchCategory()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Category Section Updated!',
        })
    }

    const props = {
        data: categoryDetail,
        items: copyItems,
        setItems,
        setSubItems,
        onChangeForm,
        onChangeItem,
        onChangeSubItem,
        onAddNewItem,
        addSubItem,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <CategoryWinner {...props} />
}
